module.exports = __webpack_public_path__ + "img/figure-12.5ab682c8.png";